import React from 'react';
import { CheckSquareFilled, CheckSquareOutlined, CloseOutlined, ShareAltOutlined } from '@ant-design/icons';

interface Props {
  count: number;
  total: number;
  onToggleSelectAll: () => void;
  onShare: () => void;
  onCancel: () => void;
}

const linkBtn: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 10px',
  border: 'none',
  background: 'transparent',
  color: '#4e5969',
  cursor: 'pointer',
  fontSize: 13,
  borderRadius: 6,
  transition: 'all 0.15s'
};

const primaryBtn: React.CSSProperties = {
  ...linkBtn,
  color: '#fff',
  background: '#1677ff'
};

export default function ShareSelectionBar({ count, total, onToggleSelectAll, onShare, onCancel }: Props) {
  const shareDisabled = count === 0;
  const allSelected = total > 0 && count === total;
  return (
    <div
      style={{
        position: 'absolute',
        top: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 6px 24px rgba(29,33,41,0.15)',
        border: '1px solid #f0f0f0',
        padding: '6px 10px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 13,
        whiteSpace: 'nowrap'
      }}
    >
      <span style={{ color: '#4e5969', padding: '0 6px' }}>
        已选择 <b style={{ color: '#1d2129', margin: '0 2px' }}>{count}</b> 条对话
      </span>
      <button
        type="button"
        onClick={onToggleSelectAll}
        disabled={total === 0}
        style={{
          ...linkBtn,
          color: allSelected ? '#1677ff' : '#4e5969',
          background: allSelected ? '#E6F0FF' : 'transparent',
          cursor: total === 0 ? 'not-allowed' : 'pointer',
          opacity: total === 0 ? 0.5 : 1
        }}
        onMouseEnter={(e) => {
          if (total === 0) return;
          e.currentTarget.style.background = allSelected ? '#D9E7FF' : '#f2f3f5';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = allSelected ? '#E6F0FF' : 'transparent';
        }}
      >
        {allSelected ? (
          <CheckSquareFilled style={{ fontSize: 13, color: '#1677ff' }} />
        ) : (
          <CheckSquareOutlined style={{ fontSize: 13 }} />
        )}
        {allSelected ? '取消全选' : '全选'}
      </button>
      <button
        type="button"
        onClick={onShare}
        disabled={shareDisabled}
        style={{
          ...primaryBtn,
          background: shareDisabled ? '#c8cfd8' : '#1677ff',
          cursor: shareDisabled ? 'not-allowed' : 'pointer'
        }}
      >
        <ShareAltOutlined style={{ fontSize: 13 }} />
        分享
      </button>
      <button
        type="button"
        onClick={onCancel}
        style={linkBtn}
        onMouseEnter={(e) => (e.currentTarget.style.background = '#f2f3f5')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <CloseOutlined style={{ fontSize: 12 }} />
        取消
      </button>
    </div>
  );
}
